import React, { useEffect, useState } from "react";
import useChatStore from "../store/useChatStore";
import ChatHeader from "../components/chat-window/ChatHeader";
import ChatFooter from "../components/chat-window/ChatFooter";
import HomePage from "./HomePage";
import OrderListPage from "./OrderListPage";
import LoginPage from "./LoginPage";
import OTPPage from "./OTPPage";
import TrackOrderPage from "./TrackOrderPage";
import OrderDetailsPage from "./OrderDetailsPage";
import ChatPage from "./ChatPage";
import SupportInfo from "./SupportInfo";
import Brand from "../common/Brand";
import TicketRised from "./TicketRised";
import TicketFetched from "./TicketFetched";
import EmailPage from "./EmailPage";
import OneToOneChat from "./OneToOneChat";

const ChatWindow = ({ closeChat }) => {
  const { currentScreen, orderDetails, faqInfo, chatbotTheme } = useChatStore();

  const [isClosing, setIsClosing] = useState(false);
  const [sqwitch, setsqwitch] = useState(500);
  const [message, setMessage] = useState("");

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      closeChat();
    }, 300);
  };

  const handelsqwitch = () => {
    setsqwitch((prevWidth) => (prevWidth === 500 ? 340 : 500));
  };

  useEffect(() => {
    if (currentScreen === "supportInfo") {
      setsqwitch(500);
    }
  }, [currentScreen]);

  const renderScreen = () => {
    switch (currentScreen) {
      case "orderList":
        return <OrderListPage />;
      case "login":
        return <LoginPage />;
      case "otp":
        return <OTPPage />;
      case "track-order":
        return <TrackOrderPage />;
      case "order-details":
        return <OrderDetailsPage order={orderDetails} />;
      case "chat":
        return <ChatPage />;
      case "supportInfo":
        return <SupportInfo faqInfo={faqInfo} />;
      case "ticketfetched":
        return <TicketFetched />;
      case "ticketrised":
        return <TicketRised />;
      case "mail-us":
        return <EmailPage />;
      case "one-to-one":
        return <OneToOneChat />;
      default:
        return <HomePage />;
    }
  };

  const chatWindowWidth = currentScreen === "supportInfo" ? sqwitch : 380;
  const isHomePage = currentScreen === "home";
  return (
    <div
      className={`chat-window ${isClosing ? "closing" : "open"}`}
      style={{
        width: `${chatWindowWidth}px`,
        transition: "width 0.3s ease",
        background: isHomePage
          ? `linear-gradient(to bottom,${chatbotTheme} 15%, #FFFFFF 60%)`
          : "",
      }}
    >
      <ChatHeader
        closeChat={handleClose}
        handelsqwitch={handelsqwitch}
        isHomePage={isHomePage}
        sqwitch={sqwitch}
      />
      {renderScreen()}
      {["order-details"].includes(currentScreen) && (
        <ChatFooter message={message} setMessage={setMessage} />
      )}
      {/*{["home"].includes(currentScreen) && <Brand />}*/}
    </div>
  );
};

export default ChatWindow;
